<template>
  <v-row class="pb-xs-8 pb-md-1"
    :style="
      `background-color: ${ color }; !important`
    "
  >
    <v-col
      :xs="12"
      :sm="6"
      :md="4"
      class="text-center d-flex align-items-center col-xs-12"
      style="min-width: 168px;max-height: 100px"
    >
      <logo type="veci-white" class="ma-auto" height="100%" />
    </v-col>
    <v-col
      :xs="12"
      :sm="6"
      :md="4"
      class="footer-text d-flex align-items-center justify-md-space-between col-xs-12"
      style="min-width: 250px;"
    >
      <div class="divider-white d-none d-sm-flex"></div>
      <div>
        <img src="../assets/email.svg" class="mx-3 my-2" /><span
          >sac@soyveci.com</span
        >
        <br />
        <img src="../assets/address.svg" class="mx-3 my-2" />
        <span>Calle 100 # 19 - 61 | Bogotá</span>
      </div>
      <div class="divider-white d-none d-md-flex"></div>
    </v-col>
    <v-col
      :xs="12"
      :md="4"
      class="footer-text text-center align-items-center justify-center flex-column d-flex"
      style="min-width: 135px;"
    >
      <div class="mx-auto">
        <a
          class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default"
          href="https://www.instagram.com/vecicolombia/"
        >
          <img src="../assets/instagram.svg" />
        </a>
        <a
          class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default"
          href="https://www.facebook.com/soyveci/"
        >
          <img src="../assets/facebook.svg" />
        </a>
        <a
          class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default"
          href="https://www.linkedin.com/company/soyveci/mycompany/"
        >
          <img src="../assets/linkedin.svg" />
        </a>
      </div>
      <a
        style="color: white;"
        href="https://soyveci.com/nuestras-politicas/"
        target="_blank"
      >
        <span>Términos y condiciones</span>
      </a>
    </v-col>
  </v-row>
</template>
<script>
import Logo from "./Logo";
export default {
  components: { Logo },
  props: {
    color: { type: String }
  }
};
</script>
<style lang="sass" scoped>
.footer-text
    color: white
.divider-white
    background-color: white
    height: 97%
    width: 1px
    margin: 0px 10px 0px 10px
</style>
